'use client';

import clsx from 'classnames';
import Link from 'next/link';
import { useEffect, useRef } from 'react';
import { useOnScreen } from 'ui';

import {
  selectPromotion,
  viewPromotion,
} from '@/modules/google/data-layer/data-layer';
import { ImageOnlyBannerModule } from '@/shared/banners/types';
import { Image } from '@/shared/components/image';

import styles from './ImageOnlyBanner.module.scss';

export function ImageOnlyBanner({
  imageBreakpoints,
  data,
  bannerId,
  name,
  slot,
}: {
  data?: ImageOnlyBannerModule['data'];
  imageBreakpoints: Record<number, number | number[]>;
  bannerId: number;
  name: string;
  slot?: string | null;
}) {
  const ref = useRef(null);
  const { onScreen, disconnect } = useOnScreen(ref);

  const handleLinkClick = () => {
    selectPromotion(name, `P${bannerId}`, slot);
  };

  useEffect(() => {
    if (!onScreen) {
      return;
    }

    disconnect();
    viewPromotion(name, `P${bannerId}`, slot);
  }, [onScreen]);

  if (!data?.imageDesktop?.url || !data?.imageMobile?.url) return null;

  return (
    <div
      ref={ref}
      className={clsx(
        'Banner',
        'ImageOnlyBanner',
        styles.ImageOnlyBanner__wrapper
      )}
    >
      <Link prefetch={false} href={data.url || '#'} onClick={handleLinkClick}>
        <Image
          containerClassName={styles.ImageOnlyBanner__wrapper__mobileImage}
          src={`${data.imageMobile.url}`}
          breakpoints={imageBreakpoints}
          loader={false}
          width={data.imageMobile.width}
          height={data.imageMobile.height}
          forcePortraitSrcSet={data.imageMobile.height > data.imageMobile.width}
          alt={data.imageAlt}
          title={data.imageTitle}
        />
        <Image
          containerClassName={styles.ImageOnlyBanner__wrapper__desktopImage}
          src={`${data.imageDesktop.url}`}
          breakpoints={imageBreakpoints}
          loader={false}
          width={data.imageDesktop.width}
          height={data.imageDesktop.height}
          forcePortraitSrcSet={
            data.imageDesktop.height > data.imageDesktop.width
          }
          alt={data.imageAlt}
          title={data.imageTitle}
        />
      </Link>
    </div>
  );
}
